module.exports = __webpack_public_path__ + "static/media/gr_pain5.b026685a.wav";